import { getCategoryId } from "../../state/modules/category";
import sdkProvider from "../sdkProvider";

const ENABLED_CATEGORY_IDS = [51163, 51164];

const newInRedirect = async ({ state }) => {
  const categoryId = getCategoryId(state);

  if (!ENABLED_CATEGORY_IDS.includes(categoryId)) {
    return;
  }

  const featuresSdk = await sdkProvider("features");
  await featuresSdk.onReady();

  const isInviteAllUsersToLoyaltyFeatureEnabled = await featuresSdk
    .getFeature("loyalty_invite_all_eligible_users")
    .isEnabled();

  if (!isInviteAllUsersToLoyaltyFeatureEnabled) {
    return false;
  }

  const identitySdk = await sdkProvider("identity");
  const isAuthenticated = await identitySdk.customer.isAuthenticated();

  if (!isAuthenticated) {
    identitySdk.login();

    return true;
  }
};

export default newInRedirect;
